import { Users } from '@/types/models';

const fetchUsers = async () => {
    const response = await fetch('/api/users/list', { method: "GET" });
    const responseJson = await response.json();
    return responseJson;
}

const updateUser = async (userId: string, userData: Partial<Users>) => {
    const response = await fetch('/api/users/update', {
        method: "PUT",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, userData })
    });
    const responseJson = await response.json();
    return responseJson;
}

const activateUser = async (userId: string) => {
    const response = await fetch('/api/users/inactive/activate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: userId }),
    });
    const responseJson = await response.json();
    return responseJson;
}

export const usersService = { fetchUsers, updateUser, activateUser }